import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0838 2.16672H11.5004V1.58336C11.5004 1.26134 11.2391 1 10.9171 1C10.5951 1 10.3337 1.26134 10.3337 1.58336V2.16672H5.66686V1.58336C5.66686 1.26134 5.40552 1 5.0835 1C4.76149 1 4.50015 1.26134 4.50015 1.58336V2.16672H3.91679C2.30847 2.16672 1 3.47519 1 5.0835V8.00029C1 8.32231 1.26134 8.58365 1.58336 8.58365C1.90537 8.58365 2.16672 8.32231 2.16672 8.00029V6.83358H13.8339V12.0838C13.8339 13.0487 13.0487 13.8339 12.0838 13.8339H3.91679C3.11759 13.8339 2.42106 13.2943 2.22155 12.5213C2.14105 12.2092 1.82195 12.0214 1.51102 12.1019C1.19892 12.1824 1.01167 12.5003 1.09159 12.8124C1.42352 14.1005 2.58498 15 3.9162 15H12.0832C13.6915 15 15 13.6915 15 12.0832V5.0835C15 3.47519 13.6921 2.16672 12.0838 2.16672ZM2.16672 5.66686V5.0835C2.16672 4.11863 2.95191 3.33343 3.91679 3.33343H12.0838C13.0487 3.33343 13.8339 4.11863 13.8339 5.0835V5.66686H2.16672ZM1.58336 9.75036H5.63653L4.72007 8.83391C4.49198 8.60582 4.49198 8.23713 4.72007 8.00904C4.94816 7.78095 5.31685 7.78095 5.54494 8.00904L7.09609 9.56019C7.52252 9.98662 7.52252 10.6802 7.09609 11.1067L5.54494 12.6578C5.43118 12.7716 5.28185 12.8287 5.13251 12.8287C4.98317 12.8287 4.83383 12.7716 4.72007 12.6578C4.49198 12.4297 4.49198 12.061 4.72007 11.833L5.63653 10.9165H1.58336C1.26134 10.9165 1 10.6552 1 10.3331C1 10.0111 1.26134 9.74978 1.58336 9.74978V9.75036Z"
      fill="#151718"
    />
  </svg>
);

const MoveIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default MoveIcon;
